import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Button,
    Flex,
    Heading,
    Text,
    HStack,
    Container,
    SimpleGrid,
} from "@chakra-ui/react";
import { primaryColor, primaryFontSize, secondaryColorThree, secondaryFontSize } from "../../../config";

const benefits = [
    {
        number: "01 · Physical",
        title: "BODY",
        question: "Sound - Vibration that can Affect!",
        tags: ["Breathe", "Release", "Restore"],
        lines: [
            "Experience greater ease in the body",
            "Relief from everyday stress and tension",
            "Let the breath deepen",
            "Let tension soften",
        ],
        activity: "Reverberation",
        bg: "#e8dccb",
    },
    {
        number: "02 · Meta Physical",
        title: "MIND",
        question: "A Field of Reverberation...",
        tags: ["Focus", "Calm", "Awareness"],
        lines: [
            "Increase Focus, Clarity & Present state of mind.",
            "Slow the noise within.",
            "Sharpen attention.",
        ],
        activity: "Resonance",
        bg: "#d9c3aa",
    },
    {
        number: "03 · Non Physical",
        title: "BEYOND",
        question: "Resonance of the highest pitch.",
        tags: ["Joy", "Expression", "Belonging"],
        lines: [
            "Find your Inner voice.",
            "Feel the rhythm of your being.",
            "Find the Community & experience the joy of expression and deeper connection.",
        ],
        activity: "Silence",
        bg: "#cec8bd",
    },
];


interface BenefitCardProps {
    number: string;
    title: string;
    question: string;
    lines?: string[];
    activity: string;
    bg: string;
}

function BenefitCard({
    number,
    title,
    question,
    activity,
    lines,
    bg,
}: BenefitCardProps) {
    return (
        <Flex
            direction="column"
            justify="space-between"
            minH={{ base: "450px", md: "420px" }}
            p={{ base: 8, md: 11 }}
            bg={bg}
        >
            <Box>
                <Text
                    fontFamily="Arial, sans-serif"
                    fontSize="11px"
                    letterSpacing=".18em"
                    color={secondaryColorThree}
                >
                    {number}
                </Text>

                <Heading
                    mt={9}
                    fontSize={{ base: "40px", md: "44px" }}
                    fontWeight="400"
                    lineHeight="1"
                    color={primaryColor}
                >
                    {title}
                </Heading>

                <Text
                    mt={9}
                    fontSize={secondaryFontSize}
                    lineHeight="1.35"
                    color={secondaryColorThree}
                >
                    {question}
                </Text>
                <Text
                    mt={9}
                    fontSize={primaryFontSize}
                    lineHeight="1.35"
                    color={primaryColor}
                >
                    {lines?.map((line, lineIndex) => (
                        <React.Fragment key={lineIndex}>
                            {line}
                            {lineIndex < lines.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </Text>
            </Box>

            <Text
                mt={9}
                pt={5}
                borderTop="1px solid rgba(37,35,31,.15)"
                fontFamily="Arial, sans-serif"
                fontSize="11px"
                letterSpacing=".1em"
                textTransform="uppercase"
                color={secondaryColorThree}
            >
                {activity}
            </Text>
        </Flex>
    );
}




function Benefits() {
    return (
        <Box
            as="section"
        >
            <Container maxW="1100px">

                <SimpleGrid
                    columns={{ base: 1, md: 3 }}
                    gap={5}

                >
                    {benefits.map((benefit) => (
                        <BenefitCard
                            key={benefit.number}
                            {...benefit}
                        />
                    ))}
                </SimpleGrid>
            </Container>
        </Box>
    );
}

export default function NadaBenefits() {

    return (
        <Box
            as="section"
            color="#f1ede5"
            px={{ base: "18px", md: "24px" }}
            overflow="hidden"
            fontFamily='"Inter", "Helvetica Neue", Arial, sans-serif'
        >
            <Box maxW="1180px" mx="auto">
                {/* Header */}
                <Box maxW="680px" mb={{ base: "35px", md: "55px" }}>
                </Box>
                <Benefits />
                <Text
                    m="0"
                    color="#b8b1a5"
                    fontSize={{ base: "11px", md: "12px" }}
                    letterSpacing="0.04em"
                    textAlign={"right"}
                >
                    <br />
                    Explore the experience. Discover what sound means to you.
                </Text>

            </Box>
        </Box>
    );
}